import { z } from "zod/v4";
import { ageClassSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export const classes = {
	list: () => fetchApi(`/classes`, z.array(ageClassSchema)),
	get: (id: string) => fetchApi(`/classes/${id}`, ageClassSchema),
	update: (id: string, body: any) =>
		fetchApi(`/classes/${id}`, ageClassSchema, { method: "PUT", body: JSON.stringify(body) }),
};
